<template>
  <!--  批量修改分类操作-->
  <el-dialog :visible.sync="modal.wmscodeVisible"
             width="650px"
             center>
    <el-form >
      <el-select style="width: 250px;" v-model="wmscodId"
                 placeholder="请选择" >
        <el-option key="0"
                   label="清空选择"
                   value="0">
        </el-option>
        <el-option v-for="item in partnerValue"
                   :key="item.wms_co_id"
                   :label="item.name"
                   :value="item.wms_co_id">
        </el-option>
      </el-select>
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="modal.wmscodeVisible = false">取 消</el-button>
      <el-button type="primary"
                 @click="handleConfirm">确 认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { partnerQuery } from '@/api/erp'
export default {
  name: "ErpWmscodModal",
  props: {
    modal: Object
  },
  data() {
    const that = this
    return {
      // 级联面板定制
      formLabelWidth: '160px',
      data: {
        productIds: null,
        wmscodId: null,
      },
      partnerValue: [],
      wmscodId: null,
    }
  },
  methods: {

    partnerQuery(){
      partnerQuery().then(res => {
        if(res.data != null){
          this.partnerValue = res.data
        }
      })
    },
    handleConfirm() {
      //console.log('listQuery', this.listQuery)
      this.$emit('handleWmscode', this.wmscodId)
    }
  }
}
</script>

<style scoped>
.notice {
  margin: 0 0 0 172px;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/views/pms/components/ErpWmscodModal.vue